module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle7.png?bc2f2f21cc9f34ad89534cbc97aa031d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle7.png
// module id = 835
// module chunks = 0